import Snappy from '../../../libs/snappy/snappy';
import {getCookie} from "../../../scripts/utilities/cookie";
import $ from 'jquery';


Snappy.Component.BursaryForm = class BursaryForm extends Snappy.BaseComponent {
    static get tagName() {
        return 'bursary-form';
    }

    constructor(element) {
        super(element);
    }

    render() {
        // todo: use logged in flag from backend, cookie solution is temporary
        const isLoggedIn = typeof getCookie('ZimbraSsoCookie') !== 'undefined';

        if (!isLoggedIn) {
            this.$window.trigger('loginPrompt:open');
        }
    }
};



// WEBPACK FOOTER //
// ./components/bursary-form/scripts/bursary-form.js